import { useEffect, useState } from "react"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { FeatureGate } from "@/components/app/FeatureGate"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { API_BASE } from "@/config/api"
import { formatDate } from "@/lib/format"
import { toast } from "sonner"

const API = API_BASE

export default function Waitlist() {
  const [rows, setRows] = useState([])
  const [clients, setClients] = useState([])
  const [clientId, setClientId] = useState("")
  const [preferredStart, setPreferredStart] = useState("")

  const load = () => axios.get(`${API}/waitlist`).then((r) => setRows(r.data)).catch(() => {})

  useEffect(() => {
    load()
    axios.get(`${API}/clients`).then((r) => setClients(r.data)).catch(() => {})
  }, [])

  const add = async () => {
    if (!clientId) return toast.error("Selectează un client")
    try {
      await axios.post(`${API}/waitlist`, {
        client_id: clientId,
        preferred_start: preferredStart || null,
      })
      setClientId("")
      setPreferredStart("")
      load()
      toast.success("Adăugat pe listă")
    } catch {
      toast.error("Eșuat")
    }
  }

  const remove = async (id) => {
    try {
      await axios.patch(`${API}/waitlist/${id}`)
      load()
      toast.success("Eliminat din listă")
    } catch {
      toast.error("Eșuat")
    }
  }

  return (
    <FeatureGate feature="waitlist">
      <AppLayout title="Listă de așteptare">
        <div className="max-w-2xl space-y-6">
          <div className="rounded-xl border border-border p-6 bg-card space-y-3">
            <h3 className="text-sm font-medium">Adaugă pe listă</h3>
            <div>
              <Label className="text-xs">Client</Label>
              <Select value={clientId} onValueChange={setClientId}>
                <SelectTrigger className="mt-1"><SelectValue placeholder="Alege client" /></SelectTrigger>
                <SelectContent>
                  {clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Preferință dată (opțional)</Label>
              <Input type="datetime-local" className="mt-1" value={preferredStart} onChange={(e) => setPreferredStart(e.target.value)} />
            </div>
            <Button className="rounded-full" onClick={add}>Adaugă</Button>
          </div>
          <ul className="divide-y divide-border rounded-xl border border-border bg-card text-sm">
            {rows.map((w) => (
              <li key={w.id} className="px-4 py-3 flex justify-between gap-4 flex-wrap items-center">
                <span className="font-medium">{w.client_name}</span>
                <span className="text-muted-foreground text-xs">{w.client_email}</span>
                <span className="text-xs">{w.preferred_start ? formatDate(w.preferred_start) : "—"}</span>
                <Button size="sm" variant="ghost" className="rounded-full text-xs" onClick={() => remove(w.id)}>
                  Elimină
                </Button>
              </li>
            ))}
            {!rows.length && <li className="px-4 py-8 text-muted-foreground text-center">Lista este goală.</li>}
          </ul>
        </div>
      </AppLayout>
    </FeatureGate>
  )
}
